(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ba-order-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ba-order-summary')) {
  customElements.define('ba-order-summary', class extends HTMLElement {
    connectedCallback() {
      this.variants = JSON.parse(this.querySelector('script').textContent);
      this.form = this.closest('form');
      this.update = this.renderSummary.bind(this);
      this.form.addEventListener('change', this.update);
      this.form.addEventListener('input', this.update);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.quantityUnsubscribe = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.update);
      }
      this.renderSummary();
    }
    disconnectedCallback() {
      this.form?.removeEventListener('change', this.update);
      this.form?.removeEventListener('input', this.update);
      this.quantityUnsubscribe?.();
    }
    renderSummary() {
      const variant = this.variants[this.form.querySelector('[name="id"]')?.value];
      const quantityInput = this.form.querySelector('[name="quantity"]');
      const quantity = Number(quantityInput?.value || 1);
      const amount = this.querySelector('[data-order-amount]');
      const total = this.querySelector('[data-order-total]');
      if (!variant || !Number.isInteger(quantity) || quantity < 1 || (quantityInput && !quantityInput.checkValidity())) {
        amount.textContent = this.dataset.unavailable;
        total.textContent = '';
        return;
      }
      amount.textContent = `${quantity} ${quantity === 1 ? this.dataset.unitOne : this.dataset.unitMany} · ${this.dataset.approx}${quantity * variant.weight} g`;
      total.textContent = new Intl.NumberFormat(this.dataset.locale || 'en', {style:'currency', currency:this.dataset.currency || 'USD'}).format(variant.price * quantity / 100);
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
